import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../../wrapper";
import Spinner from "../spinner";

function LoadingFallback() {
  return (
    <Wrapper>
      <Spinner wrapperClassName="mt-5 pt-5 w-100" />
    </Wrapper>
  );
}

function SuspenseWrapper() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Outlet />
    </Suspense>
  );
}

export default SuspenseWrapper;
